import {
  Autocomplete,
  Box,
  Button,
  Divider,
  IconButton,
  MenuItem,
  Paper,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import marker from "../../../images/Markers.png";
import InputMask from "react-input-mask";
import { useState, useEffect } from "react";
import { Add, Clear, DeleteOutline } from "@mui/icons-material";
import api from "../../../services/api";
import { validarData, getMinDate } from "../../../utils/validarData";
import { ufList } from "../../../utils/ufList";
import { dadosIniciais } from "../dadosIniciais";
import { FieldAutocomplete, FieldDatePicker } from "../../../components/Fields";
import dayjs from "dayjs";

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    gap: "24px",
  },
  boxRow: {
    display: "flex",
    gap: "24px",
  },
  typography: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    fontWeight: 600,
    color: "#063F5E",
  },
  stackText: { width: "100%" },
};

export default function IndentificaoStep({ dadosPaciente, setDadosPaciente }) {
  const [dataValida, setDataValida] = useState(true);

  const [sexoList, setSexoList] = useState();
  const [naturalidadeList, setNaturalidadeList] = useState();
  const [racaList, setRacaList] = useState();
  const [estadoCivilList, setEstadoCivilList] = useState();
  const [religiaoList, setReligiaoList] = useState();
  const [profissaoList, setProfissaoList] = useState([]);
  const [escolaridadeList, setEscolaridadeList] = useState();
  const [lateralidadeList, setLateralidadeList] = useState();
  const [tipoTrabalhoList, setTipoTrabalhoList] = useState();
  const [condicaoAtualList, setCondicaoAtualList] = useState();
  const [identidadeGeneroList, setIdentidadeGeneroList] = useState([]);
  const [municipioList, setMunicipioList] = useState([]);

  useEffect(() => {
    fetchData();

    if (dadosPaciente.estadoNascimento) {
      handleEstado(dadosPaciente.estadoNascimento);
    }
  }, []);

  const fetchData = async () => {
    try {
      await Promise.all([
        getDataProfissaoList(),
        getDataLateralidadeList(),
        getDataEstadoCivilList(),
        getDataReligiaoList(),
        getDataSexoList(),
        getDataRacaList(),
        getDataEscolaridadeList(),
        getDataNaturalidadeList(),
        getDataTipoTrabalhoList(),
        getDataCondicaoTrabalhoList(),
        getIdentidadeGeneroList(),
      ]);
    } catch (error) {
      console.error("An error occurred during data fetching:", error.message);
    } finally {
    }
  };

  const getDataLateralidadeList = async () => {
    const { data } = await api.get("/lateralidade/");
    setLateralidadeList(data.data);
  };

  const getDataEstadoCivilList = async () => {
    const { data } = await api.get("/estadocivil/");
    setEstadoCivilList(data.data);
  };

  const getDataReligiaoList = async () => {
    const { data } = await api.get("/religiao/");
    setReligiaoList(data.data);
  };

  const getDataProfissaoList = async () => {
    const { data } = await api.get("/cbo/");
    setProfissaoList(data.cbo);
  };

  const getDataSexoList = async () => {
    const { data } = await api.get("/sexo/");
    setSexoList(data.data);
  };

  const getDataRacaList = async () => {
    const { data } = await api.get("/racacor/");
    setRacaList(data.data);
  };

  const getDataEscolaridadeList = async () => {
    const { data } = await api.get("/escolaridade/");
    setEscolaridadeList(data.data);
  };

  const getDataNaturalidadeList = async () => {
    const { data } = await api.get("/pais/");
    setNaturalidadeList(data.paises);
  };

  const getDataTipoTrabalhoList = async () => {
    const { data } = await api.get("/tipoTrabalho/");
    setTipoTrabalhoList(data.data);
  };

  const getDataCondicaoTrabalhoList = async () => {
    const { data } = await api.get("/condicaoTrabalho/");
    setCondicaoAtualList(data.data);
  };

  const getIdentidadeGeneroList = async () => {
    const { data } = await api.get("/identidadegenero/");
    setIdentidadeGeneroList(data.data);
  };

  const handleEstado = async (uf_id) => {
    if (uf_id === "" || uf_id === undefined || uf_id === null) {
      setDadosPaciente((prevState) => ({
        ...prevState,
        estadoNascimento: "",
        municipioNascimento: "",
      }));

      setMunicipioList([]);
      return;
    }

    setDadosPaciente((prevState) => ({
      ...prevState,
      estadoNascimento: uf_id.toString(),
    }));

    try {
      const { data } = await api.post("/city", {
        state_id: parseInt(uf_id),
      });

      data.unshift({ co_ibge: "", no_descricao: "Selecione" });

      setMunicipioList(data);
    } catch (error) {
      console.error("Ocorreu um erro:", error.message);
    }
  };

  const addDadosContato = () => {
    if (dadosPaciente.dadosDeContato.length < 5) {
      setDadosPaciente((prevState) => ({
        ...prevState,
        dadosDeContato: [
          ...dadosPaciente.dadosDeContato,
          { telefone: "", nome: "" },
        ],
      }));
    }
  };

  const removeDadosContato = (index) => {
    const newDadosContato = [...dadosPaciente.dadosDeContato];
    newDadosContato.splice(index, 1);
    setDadosPaciente((prevState) => ({
      ...prevState,
      dadosDeContato: newDadosContato,
    }));
  };
  return (
    <Box sx={styles.container}>
      <Box sx={{ ...styles.boxRow }} id={"coluna1"}>
        <Stack direction={"column"} width={"100%"}>
          <Typography sx={styles.typography}>
            Nome <img src={marker} alt="maker" />
          </Typography>
          <TextField
            required
            id={"nome"}
            fullWidth
            value={dadosPaciente.nome}
            onChange={(event) => {
              setDadosPaciente((prevState) => ({
                ...prevState,
                nome: event.target.value,
              }));
            }}
          />
        </Stack>
      </Box>
      <Box sx={styles.boxRow} id={"coluna2"}>
        <Stack direction={"column"} width={"100%"}>
          <Typography sx={styles.typography}>
            Nome da mãe <img src={marker} alt="maker" />
          </Typography>
          <TextField
            required
            id={"nome-da-mae"}
            fullWidth
            value={dadosPaciente.nomeDaMae}
            onChange={(event) => {
              setDadosPaciente((prevState) => ({
                ...prevState,
                nomeDaMae: event.target.value,
              }));
            }}
          />
        </Stack>
      </Box>
      <Box sx={styles.boxRow} id={"coluna3"}>
        <Stack direction={"column"} width={"100%"}>
          <Typography sx={styles.typography}>Nome social</Typography>
          <TextField
            id={"nome-social"}
            fullWidth
            value={dadosPaciente.nomeSocial}
            onChange={(event) => {
              setDadosPaciente((prevState) => ({
                ...prevState,
                nomeSocial: event.target.value,
              }));
            }}
          />
        </Stack>
      </Box>
      <Box
        sx={{
          ...styles.boxRow,
          flexDirection: { xs: "column", sm: "row" },
        }}
        id={"coluna4"}
      >
        <Stack sx={styles.stackText}>
          <Typography sx={styles.typography}>
            Sexo <img src={marker} alt="maker" />
          </Typography>
          <Select
            required
            value={dadosPaciente.sexo}
            onChange={(event) => {
              setDadosPaciente((prevState) => ({
                ...prevState,
                sexo: event.target.value,
              }));
            }}
            sx={{
              height: "40px",
            }}
          >
            <MenuItem value="" disabled>
              Selecione
            </MenuItem>
            {sexoList?.map(({ no_descricao, co_id }) => {
              return (
                <MenuItem value={co_id} key={co_id}>
                  {no_descricao}
                </MenuItem>
              );
            })}
          </Select>
        </Stack>
        <Stack sx={styles.stackText}>
          <Typography sx={styles.typography}>Identidade de gênero</Typography>
          <Select
            value={dadosPaciente.identidadeDeGenero}
            onChange={(event) => {
              setDadosPaciente((prevState) => ({
                ...prevState,
                identidadeDeGenero: event.target.value,
              }));
            }}
            sx={{
              height: "40px",
            }}
            endAdornment={
              <IconButton
                sx={{ display: dadosPaciente.identidadeDeGenero ? "" : "none" }}
                onClick={() =>
                  setDadosPaciente((prevState) => ({
                    ...prevState,
                    identidadeDeGenero: "",
                  }))
                }
              >
                <Clear sx={{ mr: 1 }} />
              </IconButton>
            }
          >
            <MenuItem value="" disabled>
              Selecione
            </MenuItem>
            {identidadeGeneroList?.map(({ no_descricao, co_id }) => {
              return (
                <MenuItem value={co_id} key={co_id}>
                  {no_descricao}
                </MenuItem>
              );
            })}
          </Select>
        </Stack>
      </Box>
      <Box
        sx={{
          ...styles.boxRow,
          flexDirection: { xs: "column", sm: "row" },
        }}
        id={"coluna5"}
      >
        <FieldDatePicker
          label="Data de nascimento"
          value={dadosPaciente.dataNascimento}
          setValue={(value) => {
            const dt = dayjs(value).format("YYYY-MM-DD");
            setDataValida(validarData(dt));
            setDadosPaciente((prevState) => ({
              ...prevState,
              dataNascimento: dt,
            }));
          }}
          labelDatePicker={"dia/mê/ano"}
          required
          minDate={dayjs(getMinDate())}
          maxDate={dayjs()}
          error={!dataValida}
          helperText={dataValida ? "" : "Informe uma data válida"}
        />

        <Stack sx={styles.stackText}>
          <Typography sx={styles.typography}>
            Naturalidade <img src={marker} alt="maker" />
          </Typography>
          <Autocomplete
            required
            disablePortal
            value={
              naturalidadeList
                ? naturalidadeList.find(
                    (option) => option.co_id === dadosPaciente.naturalidade
                  )
                : null
            }
            options={naturalidadeList}
            getOptionLabel={(option) => option.no_nome || ""}
            onChange={(event, value) => {
              setDadosPaciente((prevState) => ({
                ...prevState,
                naturalidade: event.target.value,
              }));
            }}
            sx={{ ...styles.input, width: "100%" }}
            noOptionsText={"Não encontrado"}
            renderInput={(params) => (
              <TextField required defaultValue="Brasil" {...params} />
            )}
          />
        </Stack>
      </Box>
      <Box
        sx={{
          ...styles.boxRow,
          flexDirection: { xs: "column", sm: "row" },
        }}
        id={"coluna6"}
      >
        <Stack sx={styles.stackText}>
          <Typography sx={styles.typography}>Estado de nascimento</Typography>
          <Autocomplete
            disabled={dadosPaciente.naturalidade !== 23}
            disablePortal
            sx={{ ...styles.input, width: "100%" }}
            id="demo-simple-select"
            options={ufList}
            value={
              ufList.find(
                (option) => option.codigo_uf === dadosPaciente.estadoNascimento
              ) || null
            }
            defaultValue={""}
            getOptionLabel={(option) => option.unidade_federativa || ""}
            onChange={(event, value) => handleEstado(value?.codigo_uf)}
            renderInput={(params) => <TextField required {...params} />}
          />
        </Stack>
        <Stack sx={styles.stackText}>
          <FieldAutocomplete
            label="Município de nascimento"
            disabled={
              municipioList?.length === 0 || dadosPaciente.naturalidade !== 23
            }
            getOptionLabel={(option) => option.no_descricao || ""}
            options={municipioList}
            value={
              municipioList
                ? municipioList.find(
                    (option) =>
                      option.co_ibge === dadosPaciente.municipioNascimento
                  )
                : null
            }
            setValue={(event, value) =>
              setDadosPaciente((prevState) => ({
                ...prevState,
                municipioNascimento: value?.co_ibge,
              }))
            }
          />
        </Stack>
      </Box>
      <Box
        sx={{
          ...styles.boxRow,
          flexDirection: { xs: "column", sm: "row" },
        }}
        id={"coluna7"}
      >
        <Stack sx={styles.stackText}>
          <Typography sx={styles.typography}>
            Raça <img src={marker} alt="maker" />
          </Typography>
          <Select
            labelId="demo-simple-select-label"
            required
            sx={{ ...styles.input, width: "100%" }}
            id="demo-simple-select"
            value={dadosPaciente.raca}
            displayEmpty
            onChange={(event) => {
              setDadosPaciente((prevState) => ({
                ...prevState,
                raca: event.target.value,
              }));
            }}
            endAdornment={
              <IconButton
                sx={{ display: dadosPaciente.raca ? "" : "none" }}
                onClick={() =>
                  setDadosPaciente((prevState) => ({
                    ...prevState,
                    raca: "",
                  }))
                }
              >
                <Clear sx={{ mr: 1 }} />
              </IconButton>
            }
          >
            <MenuItem value="" disabled>
              Selecione
            </MenuItem>
            {racaList?.map(({ no_descricao, co_id }) => {
              return (
                <MenuItem value={co_id} key={co_id}>
                  {no_descricao}
                </MenuItem>
              );
            })}
          </Select>
        </Stack>
        <Stack sx={styles.stackText}>
          <Typography sx={styles.typography}>
            Estado Civil <img src={marker} alt="maker" />{" "}
          </Typography>
          <Select
            labelId="demo-simple-select-label"
            required
            sx={{ ...styles.input, width: "100%" }}
            id="demo-simple-select"
            value={dadosPaciente.estadoCivil}
            displayEmpty
            onChange={(event) => {
              setDadosPaciente((prevState) => ({
                ...prevState,
                estadoCivil: event.target.value,
              }));
            }}
          >
            <MenuItem value="" disabled>
              Selecione
            </MenuItem>
            {estadoCivilList?.map(({ no_descricao, co_id }) => {
              return (
                <MenuItem value={co_id} key={co_id}>
                  {no_descricao}
                </MenuItem>
              );
            })}
          </Select>
        </Stack>
      </Box>
      <Box
        sx={{
          ...styles.boxRow,
          flexDirection: { xs: "column", sm: "row" },
        }}
        id={"coluna8"}
      >
        <Stack sx={styles.stackText}>
          <Typography sx={styles.typography}>Lateralidade</Typography>
          <Select
            labelId="demo-simple-select-label"
            sx={{ ...styles.input, width: "100%" }}
            id="demo-simple-select"
            value={dadosPaciente.lateralidade}
            displayEmpty
            onChange={(event) => {
              setDadosPaciente((prevState) => ({
                ...prevState,
                lateralidade: event.target.value,
              }));
            }}
            endAdornment={
              <IconButton
                sx={{ display: dadosIniciais.lateralidade ? "" : "none" }}
                onClick={() =>
                  setDadosPaciente((prevState) => ({
                    ...prevState,
                    lateralidade: "",
                  }))
                }
              >
                <Clear sx={{ mr: 1 }} />
              </IconButton>
            }
          >
            <MenuItem value="" disabled>
              Selecione
            </MenuItem>
            {lateralidadeList?.map(({ no_descricao, co_id }) => {
              return (
                <MenuItem value={co_id} key={co_id}>
                  {no_descricao}
                </MenuItem>
              );
            })}
          </Select>
        </Stack>
        <Stack sx={styles.stackText}>
          <Typography sx={styles.typography}>
            Escolaridade <img src={marker} alt="maker" />{" "}
          </Typography>
          <Select
            labelId="demo-simple-select-label"
            required
            sx={{ ...styles.input, width: "100%" }}
            id="demo-simple-select"
            value={dadosPaciente.escolaridade}
            displayEmpty
            onChange={(event) => {
              setDadosPaciente((prevState) => ({
                ...prevState,
                escolaridade: event.target.value,
              }));
            }}
          >
            <MenuItem value="" disabled>
              Selecione
            </MenuItem>
            {escolaridadeList?.map(({ no_descricao, co_id }) => {
              return (
                <MenuItem value={co_id} key={co_id}>
                  {no_descricao}
                </MenuItem>
              );
            })}
          </Select>
        </Stack>
      </Box>
      <Box
        sx={{
          ...styles.boxRow,
          flexDirection: { xs: "column", sm: "row" },
        }}
        id={"coluna9"}
      >
        <Stack sx={styles.stackText}>
          <FieldAutocomplete
            label="Profissão"
            getOptionLabel={(option) => option.no_descricao || ""}
            options={profissaoList}
            value={profissaoList?.find(
              (option) => option.co_id == dadosPaciente.profissao
            )}
            setValue={(event, value) =>
              setDadosPaciente((prevState) => ({
                ...prevState,
                profissao: value?.co_id,
              }))
            }
            required
          />
        </Stack>
        <Stack sx={styles.stackText}>
          <Typography sx={styles.typography}>Tipo de trabalho</Typography>
          <Select
            labelId="demo-simple-select-label"
            sx={{ ...styles.input, width: "100%" }}
            id="demo-simple-select"
            value={dadosPaciente.tipoDeTrabalho}
            displayEmpty
            onChange={(event) => {
              setDadosPaciente((prevState) => ({
                ...prevState,
                tipoDeTrabalho: event.target.value,
              }));
            }}
            endAdornment={
              <IconButton
                sx={{ display: dadosPaciente.tipoDeTrabalho ? "" : "none" }}
                onClick={() =>
                  setDadosPaciente((prevState) => ({
                    ...prevState,
                    tipoDeTrabalho: "",
                  }))
                }
              >
                <Clear sx={{ mr: 1 }} />
              </IconButton>
            }
          >
            <MenuItem value="" disabled>
              Selecione
            </MenuItem>
            {tipoTrabalhoList?.map(({ no_descricao, co_id }) => {
              return (
                <MenuItem value={co_id} key={co_id}>
                  {no_descricao}
                </MenuItem>
              );
            })}
          </Select>
        </Stack>
      </Box>
      <Box sx={styles.boxRow} id={"coluna10"}>
        <Stack direction={"column"} width={"100%"}>
          <Typography sx={styles.typography}>
            Útimas atividades profissionais
          </Typography>
          <TextField
            id={"atividades-profissionais"}
            fullWidth
            value={dadosPaciente.ultimasAtividades}
            onChange={(event) => {
              setDadosPaciente((prevState) => ({
                ...prevState,
                ultimasAtividades: event.target.value,
              }));
            }}
          />
        </Stack>
      </Box>
      <Box
        sx={{
          ...styles.boxRow,
          flexDirection: { xs: "column", sm: "row" },
        }}
        id={"coluna11"}
      >
        <Stack sx={styles.stackText}>
          <Typography sx={styles.typography}>Condição atual</Typography>
          <Select
            labelId="demo-simple-select-label"
            sx={{ ...styles.input, width: "100%" }}
            id="demo-simple-select"
            value={dadosPaciente.condicaoAtual}
            displayEmpty
            onChange={(event) => {
              setDadosPaciente((prevState) => ({
                ...prevState,
                condicaoAtual: event.target.value,
              }));
            }}
            endAdornment={
              <IconButton
                sx={{ display: dadosPaciente.condicaoAtual ? "" : "none" }}
                onClick={() =>
                  setDadosPaciente((prevState) => ({
                    ...prevState,
                    condicaoAtual: "",
                  }))
                }
              >
                <Clear sx={{ mr: 1 }} />
              </IconButton>
            }
          >
            <MenuItem value="" disabled>
              Selecione
            </MenuItem>
            {condicaoAtualList?.map(({ no_descricao, co_id }) => {
              return (
                <MenuItem value={co_id} key={co_id}>
                  {no_descricao}
                </MenuItem>
              );
            })}
          </Select>
        </Stack>
        <Stack sx={styles.stackText}>
          <Typography sx={styles.typography}>Há quanto tempo?</Typography>
          <TextField
            placeholder="digite em anos"
            type="number"
            fullWidth
            value={dadosPaciente.quantoTempo}
            onChange={(event) => {
              setDadosPaciente((prevState) => ({
                ...prevState,
                quantoTempo: event.target.value,
              }));
            }}
          />
        </Stack>
      </Box>
      <Box
        sx={{
          ...styles.boxRow,
          flexDirection: { xs: "column", sm: "row" },
        }}
        id={"coluna12"}
      >
        <Stack sx={styles.stackText}>
          <Typography sx={styles.typography}>Religião</Typography>
          <Select
            labelId="demo-simple-select-label"
            sx={{ ...styles.input, width: "100%" }}
            id="demo-simple-select"
            value={dadosPaciente.religiao}
            displayEmpty
            onChange={(event) => {
              setDadosPaciente((prevState) => ({
                ...prevState,
                religiao: event.target.value,
              }));
            }}
            endAdornment={
              <IconButton
                sx={{ display: dadosPaciente.religiao ? "" : "none" }}
                onClick={() =>
                  setDadosPaciente((prevState) => ({
                    ...prevState,
                    religiao: "",
                  }))
                }
              >
                <Clear sx={{ mr: 1 }} />
              </IconButton>
            }
          >
            <MenuItem value="" disabled>
              Selecione
            </MenuItem>
            {religiaoList?.map(({ no_descricao, co_id }) => {
              return (
                <MenuItem value={co_id} key={co_id}>
                  {no_descricao}
                </MenuItem>
              );
            })}
          </Select>
        </Stack>
        <Stack sx={styles.stackText} />
      </Box>
      <Box sx={styles.boxRow} id={"coluna13"}>
        <Stack width={"100%"} gap={"24px"}>
          <Typography
            sx={{ fontSize: "22px", fontWeight: 500, color: "#1E729F" }}
          >
            Dados de contato
          </Typography>
          <Stack>
            <Paper variant={"outlined"} sx={{ padding: "8px 32px" }}>
              <Stack
                direction={"row"}
                justifyContent={"space-between"}
                alignItems={"center"}
              >
                <Typography
                  sx={{ fontSize: "16px", fontWeight: 500, color: "#1E729F" }}
                >
                  Contato
                </Typography>

                <Typography
                  sx={{ fontSize: "16px", fontWeight: 500, color: "#1E729F" }}
                >
                  Ação
                </Typography>
              </Stack>
            </Paper>
            <div style={{ backgroundColor: "#D3E3EB", padding: "8px 0" }}>
              {dadosPaciente.dadosDeContato.map((contato, index) => {
                return (
                  <Stack
                    direction={{ xs: "column", sm: "row" }}
                    gap={"32px"}
                    paddingX={"30px"}
                    paddingY={"8px"}
                    justifyContent={"center"}
                    key={index}
                  >
                    <Stack sx={{ width: "100%" }}>
                      <Typography sx={styles.typography}>
                        Telefone <img src={marker} alt="maker" />
                      </Typography>

                      <InputMask
                        required
                        name={"telefone"}
                        mask={
                          dadosPaciente.dadosDeContato[index].telefone.replace(
                            " ",
                            ""
                          ).length < 14
                            ? "(99)9999-99999"
                            : "(99)9 9999-9999"
                        }
                        maskChar=""
                        value={
                          dadosPaciente.dadosDeContato[index]?.telefone || null
                        }
                        onChange={(event) =>
                          setDadosPaciente((prevState) => ({
                            ...prevState,
                            dadosDeContato: dadosPaciente.dadosDeContato.map(
                              (item, i) => {
                                if (i === index) {
                                  return {
                                    ...item,
                                    telefone: event.target.value,
                                  };
                                }
                                return item;
                              }
                            ),
                          }))
                        }
                      >
                        {(inputProps) => (
                          <TextField
                            {...inputProps}
                            fullWidth
                            sx={{ backgroundColor: "white" }}
                            autoComplete="off"
                          />
                        )}
                      </InputMask>
                    </Stack>
                    <Stack sx={{ width: "100%" }}>
                      <Typography sx={styles.typography}>
                        Nome <img src={marker} alt="maker" />
                      </Typography>
                      <TextField
                        required
                        sx={{ backgroundColor: "white" }}
                        autoComplete="off"
                        value={
                          dadosPaciente.dadosDeContato[index]?.nome || null
                        }
                        onChange={(event) =>
                          setDadosPaciente((prevState) => ({
                            ...prevState,
                            dadosDeContato: dadosPaciente.dadosDeContato.map(
                              (item, i) => {
                                if (i === index) {
                                  return {
                                    ...item,
                                    nome: event.target.value,
                                  };
                                }
                                return item;
                              }
                            ),
                          }))
                        }
                      />
                    </Stack>
                    <Stack
                      sx={{
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {dadosPaciente.dadosDeContato.length > 1 && (
                        <IconButton onClick={removeDadosContato}>
                          <DeleteOutline
                            fontSize="medium"
                            sx={{ color: "#063F5E" }}
                          />
                        </IconButton>
                      )}
                    </Stack>
                  </Stack>
                );
              })}
            </div>
          </Stack>
          <Stack direction={"row"} justifyContent={"flex-end"}>
            <Button
              variant="outlined"
              onClick={() => {
                addDadosContato();
              }}
              startIcon={<Add sx={{ mt: -0.3 }} />}
            >
              Adicionar contato
            </Button>
          </Stack>
          <Divider />
        </Stack>
      </Box>
    </Box>
  );
}
